import React from 'react';
import { Flex, Icon, Expandable, Block } from '@haldor/ui';
import { useTranslate } from 'lib/translate';
import DOMPurify from 'dompurify';
import { capitalize } from 'helpers/content';
import { Collapsible } from 'UI';
import './_OnlyFeedbackForm.scss';
var DisplayOnlyFeedback = function DisplayOnlyFeedback(props) {
  var translate = useTranslate();
  var part = props.part,
    block = props.block;
  var assessment = block.api.getEditor().getProp('assessment');
  var renderTitle = function renderTitle() {
    return /*#__PURE__*/React.createElement("div", {
      className: "df aic jcb"
    }, translate('Feedback'));
  };
  var feedbacks = [];
  if (assessment != null) {
    var _assessment$assessmen;
    feedbacks = (_assessment$assessmen = assessment.assessmentFeedbacks) === null || _assessment$assessmen === void 0 ? void 0 : _assessment$assessmen.filter(function (feedback) {
      return feedback.assessmentBlockPartId == part.id;
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "only-feedback-container"
  }, /*#__PURE__*/React.createElement(Expandable, {
    open: true,
    title: renderTitle(),
    color: "#777",
    ignorePropsUpdate: true
  }, feedbacks != null && feedbacks.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "feedbacks"
  }, feedbacks.map(function (feedback) {
    return /*#__PURE__*/React.createElement(Collapsible, {
      key: feedback.id,
      trigger: translate('Feedback'),
      defaultOpen: true
    }, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: feedback.text
      }
    }));
  })) : null));
};
DisplayOnlyFeedback.defaultProps = {
  assessments: [],
  disabled: false
};
export default DisplayOnlyFeedback;